<template>
  <!-- Add Mail Modal -->
  <div id="add_mail" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-if="isAddMode">Add Mail</h5>
          <h5 class="modal-title" v-else-if="isEditMode">Edit Mail</h5>
          <button ref="Close" v-show="showClose" type="button" class="btn-close"  data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="isAddMode">
          <div class="mb-3">
            <p>Are you adding record for a manager account or a separate email address?</p>

            <div class="mt-3">
              <div class="form-check form-check-inline" v-for="option in userOptions" :key="option.value">
                <input class="form-check-input" type="radio" :id="option.value" name="userType" :value="option.value"
                  v-model="mailLink" @change="onMailOptionChange" />
                <label class="form-check-label" :for="option.value">{{ option.label }}</label>
              </div>
            </div>
          </div>
          <div class="input-block mb-3" v-if="mailLink == mailLinkUserFlag && isAddMode">
            <label class="col-form-label">Select Manager<span class="text-danger">*</span></label>

            <vue-select v-model="selectedManager" :options="manager_ids" placeholder="Select Manager"
              name="selectedManager" id="selectedManager" @select="mySelectEvent($event, 'selectedManager')" />

          </div>
          <div class="input-block mb-3" v-if="mailLink == mailLinkEmailFlag && isAddMode">
            <label class="col-form-label">Email<span class="text-danger">*</span></label>
            <input class="form-control" label="Email" hide-details v-model="email" placeholder="Email" />

          </div>
          </div>
          <div v-if="showOptions">
            <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox hide-details v-model="isDailyReport" label="Daily report"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="8">
                <p>You will receive a report at midnight, detailing the user's work schedule, the time they arrived and
                  left.</p>
              </v-col>
              <v-col cols="12" sm="6" v-if="isDailyReport && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allRoles" item-title="name" item-value="id" label="Select Role(s)"
                 chips v-model="selectedDailyReportRoles" small-chips></v-select>
              </v-col>
              <v-col cols="12" sm="6" v-if="isDailyReport && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allLocations" item-title="name" item-value="id"
                  label="Select Location(s)" chips v-model="selectedDailyReportLocations" small-chips></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox v-model="isVisitor" label="Visitor/Contactor Notify"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="8">
                <ul>
                  You will receive and email when
                  <li>a visitor/contractor signs-in or out</li>
                  <li>contractor has stayed on site beyond their allotted time</li>
                </ul>
                <p></p>
              </v-col>

              <v-col cols="12" sm="12" v-if="isVisitor && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allLocations" item-title="name" item-value="id"
                  label="Select Location(s)" chips hide-details v-model="selectedVisitorLocation"
                  small-chips></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox v-model="isBankedTime" label="Banked time report"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="8">
                <p>You will receive an email at midnight detailing the banked time accumulated by the users</p>
              </v-col>
              <v-col cols="12" sm="6" v-if="isBankedTime && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allRoles" item-title="name" item-value="id" hide-details
                  label="Select Role(s)" chips v-model="selectedBankedTimeReportRoles" small-chips></v-select>
              </v-col>
              <v-col cols="12" sm="6" v-if="isBankedTime && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allLocations" item-title="name" item-value="id" hide-details
                  label="Select Location(s)" chips v-model="selectedBankedTimeReportLocations" small-chips></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

         <!--   <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox v-model="isLeaveTime" label="Leave time report"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="8">
                <p>You will receive an email at midnight detailing the leave time accumulated by the users</p>
              </v-col>
              <v-col cols="12" sm="6" v-if="isLeaveTime && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allRoles" item-title="name" item-value="id" hide-details
                  label="Select Role(s)" chips v-model="selectedLeaveTimeReportRoles" small-chips></v-select>
              </v-col>
              <v-col cols="12" sm="6" v-if="isLeaveTime && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allLocations" item-title="name" item-value="id" hide-details
                  label="Select Location(s)" chips v-model="selectedLeaveTimeReportLocations" small-chips></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-divider></v-divider>
              </v-col>
            </v-row> -->

            <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox v-model="isOnSiteMember" label="Members on site"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="8">
                <p>You will receive an email at midnight detailing the members that are still on site(or they forgot to
                  sign out at the end of their shift)</p>
              </v-col>
              <v-col cols="12" sm="12" v-if="isOnSiteMember && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allLocations" item-title="name" item-value="id" hide-details
                  label="Select Location(s)" chips v-model="selectedOnSiteReportLocations" small-chips></v-select>
              </v-col>
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox v-model="isUnrecognizedActivity" label="Unrecognized activity"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="8">
                <p>You will receive an email when an unauthorized activity is detected by the system(works only for face
                  recognition)</p>
              </v-col>

              <v-col cols="12" sm="12" v-if="isUnrecognizedActivity && mailLink == mailLinkEmailFlag">
                <v-select variant="outlined" density="comfortable" multiple :items="allLocations" item-title="name" item-value="id" hide-details
                  label="Select Location(s)" chips v-model="selectedUnrecognizedActivityReportLocations"
                  small-chips></v-select>
              </v-col>
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </div>
          <div class="d-flex justify-content-end mt-10">
             <div class="btn btn-light" @click="closeClicked">Close</div>
          <div  class="btn btn-primary ms-3" v-if="isAddMode" text @click="addClicked">Add</div>
          <div  class="btn btn-primary ms-3" v-else-if="isEditMode" text @click="addClicked">Update</div>
          </div>
          
       </div>
      </div>
    </div>
  </div>
  <!-- /Add Mail Modal -->
 <!-- Delete Mail Modal -->
  <div class="modal custom-modal fade" id="delete_mail" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Mail</h3>
            <p>Are you sure want to delete this mail?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="deleteMail" data-bs-dismiss="modal"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Mail Modal -->

</template>

<script>
import axios from "axios";
import { MAIL } from "../../utils/util-constants";
import { VUE_APP_API_BASE_URL } from "../../config";
export default {
  data() {
    return {
      select2: null,
      selectedManager: -1,
      manager_ids: null,

      dialog: false,
      isLoading: false,
      showClose: false,

      isAddMode: false,
      isEditMode: false,
      showOptions: false,
      isManagerSelected: false,

      isInitialDataLoaded: false,

      //flags
      mailLinkUserFlag: MAIL.LINK.USER,
      mailLinkEmailFlag: MAIL.LINK.EMAIL,

      dailyReportFlag: MAIL.TYPE.DAILY_REPORT,
      bankedTimeFlag: MAIL.TYPE.BANKED_TIME,
      leaveTimeFlag: MAIL.TYPE.LEAVE_TIME,
      onSiteMemberFlag: MAIL.TYPE.ON_SITE_MEMBER,
      visitorFlag: MAIL.TYPE.VISITOR,
      unrecognizedActivityFlag: MAIL.TYPE.UNRECOGNIZED_ACTIVITY,
      //flags end

      mailLink: -1,

      allRoles: [],
      allLocations: [],
      allManagers: [],

      isDailyReport: false,
      isVisitor: false,
      isBankedTime: false,
      isLeaveTime: false,
      isOnSiteMember: false,
      isUnrecognizedActivity: false,

      manager: -1,
      email: "",
      mailId: -1,
      deteteId:-1,

      selectedDailyReportLocations: [],
      selectedDailyReportRoles: [],
      selectedVisitorLocation: [],
      selectedBankedTimeReportLocations: [],
      selectedBankedTimeReportRoles: [],
      selectedLeaveTimeReportLocations: [],
      selectedLeaveTimeReportRoles: [],
      selectedOnSiteReportLocations: [],
      selectedUnrecognizedActivityReportLocations: [],
      userOptions: [],

    };
  },
  created() {
    this.userOptions = [
      { label: 'Site Manager/Manager', value: this.mailLinkUserFlag },
      { label: 'Email', value: this.mailLinkEmailFlag }
    ];
  },
  mounted() {
    this.getAllManagers(),
    this.getLocationIds(),
    this.getCompanyRoles()
  },
  methods: {
    showAdd() {
      this.dialog = true;
      this.isAddMode = true;
      this.isEditMode = false;
    },
    onMailOptionChange() {
      this.showOptions = false;
      if (this.mailLink == this.mailLinkUserFlag && this.isManagerSelected) {
        this.showOptions = true;
      } else if (this.mailLink == this.mailLinkEmailFlag) {
        this.showOptions = true;
      }
    },

    showEdit(mailId) {
      this.showAdd();
      this.isAddMode = false;
      this.isEditMode = true;
      this.mailId = mailId.id;

      this.showOptions = true;
      this.getMail();
    },

    async getAllManagers() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/all-manager-list`)
        .then((response) => {
          if (response.data.status) {
            this.manager_ids = response.data.data;
            this.manager_ids.forEach(element => {

              element['text'] = element['first_name'] + ' ' + element['last_name'];
              delete element['first_name'];
              delete element['last_name'];

            })
          } else {
            this.errorMessage = response.data.message || response.data.errors;
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },

    mySelectEvent(event, input) {
      switch (input) {
        case 'selectedManager':
          this.selectedManager = event.id;
          if (this.selectedManager != -1) {
            this.isManagerSelected = true;
          }

          if (this.mailLink == this.mailLinkUserFlag && this.isManagerSelected) {
            this.showOptions = true;
          }
          break;
        case 'company_role_id':
          this.company_role_id = event.id;
          break;  
        default:
          break;
      }
    },

    async getMail() {
      var instance = this;
      instance.isLoading = true;

      await axios.post(`${VUE_APP_API_BASE_URL}/mail/view`, { mailId: this.mailId })
        .then(function (response) {
          var mail = response.data.mail;
          instance.email = mail.email;
          instance.mailLink = mail.link;
          instance.selectedManager = mail.user_id;

          var mailOptions = response.data.mailLink;
          instance.formatMailLink(mailOptions, instance);

          var success = response.data.success;
        })
        .catch(error => {
          alert(error);
        })
        .then(() => {
          instance.isLoading = false;
        });
    },

    formatMailLink(mailOptions, instance) {
      mailOptions.forEach(option => {
        var type = option.type;
        var roleId = option.role_id;
        var locationId = option.location_id;

        if (type == instance.dailyReportFlag) {
          instance.isDailyReport = true;

          if (instance.mailLink == instance.mailLinkEmailFlag) {
            if (roleId) {
              instance.selectedDailyReportRoles.push(roleId);
            } else if (locationId) {
              instance.selectedDailyReportLocations.push(locationId);
            }
          }
        }

        if (type == instance.bankedTimeFlag) {
          instance.isBankedTime = true;

          if (instance.mailLink == instance.mailLinkEmailFlag) {
            if (roleId) {
              instance.selectedBankedTimeReportRoles.push(roleId);
            } else if (locationId) {
              instance.selectedBankedTimeReportLocations.push(locationId);
            }
          }
        }

        if (type == instance.leaveTimeFlag) {
          instance.isLeaveTime = true;

          if (instance.mailLink == instance.mailLinkEmailFlag) {
            if (roleId) {
              instance.selectedLeaveTimeReportRoles.push(roleId);
            } else if (locationId) {
              instance.selectedLeaveTimeReportLocations.push(locationId);
            }
          }
        }

        if (type == instance.onSiteMemberFlag) {
          instance.isOnSiteMember = true;

          if (instance.mailLink == instance.mailLinkEmailFlag) {
            if (locationId) {
              instance.selectedOnSiteReportLocations.push(locationId);
            }
          }
        }

        if (type == instance.visitorFlag) {
          instance.isVisitor = true;

          if (instance.mailLink == instance.mailLinkEmailFlag) {
            if (locationId) {
              instance.selectedVisitorLocation.push(locationId);
            }
          }
        }

        if (type == instance.unrecognizedActivityFlag) {
          instance.isUnrecognizedActivity = true;

          if (instance.mailLink == instance.mailLinkEmailFlag) {
            if (locationId) {
              instance.selectedUnrecognizedActivityReportLocations.push(
                locationId
              );
            }
          }
        }
      });
    },

    closeClicked() {
      this.mailLink = -1;

      this.isDailyReport = false;
      this.isVisitor = false;
      this.isBankedTime = false;
      this.isLeaveTime = false;
      this.isOnSiteMember = false;
      this.isUnrecognizedActivity = false;

      this.showOptions = false;

      this.selectedManager = -1;
      this.email = "";

      this.selectedDailyReportLocations = [];
      this.selectedDailyReportRoles = [];
      this.selectedVisitorLocation = [];
      this.selectedBankedTimeReportLocations = [];
      this.selectedBankedTimeReportRoles = [];
      this.selectedLeaveTimeReportLocations = [];
      this.selectedLeaveTimeReportRoles = [];
      this.selectedOnSiteReportLocations = [];
      this.selectedUnrecognizedActivityReportLocations = [];

      this.$refs.Close.click();
    },

    async getMasterCategories() {
      await axios.get(`${VUE_APP_API_BASE_URL}/master-category`)
        .then((response) => {
          if (response.data.status) {
            this.masterCategoryIds = response.data.data;
            this.masterCategoryIds.forEach(element => {

              element['text'] = element['name'];
              delete element['name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getEmployeeList() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeIds = response.data.data;
            this.employeeIds.forEach(element => {

              element['text'] = element['first_name'] + ' ' + element['last_name'];
              delete element['first_name'];
              delete element['last_name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    formatData() {
      var data = {};
      data.mailLink = this.mailLink;

      if (this.mailLink == this.mailLinkUserFlag) {
        data.userId = this.selectedManager;
      } else if (this.mailLink == this.mailLinkEmailFlag) {
        data.email = this.email;
      }

      data.isDailyReport = this.isDailyReport;
      data.isVisitor = this.isVisitor;
      data.isBankedTime = this.isBankedTime;
      data.isLeaveTime = this.isLeaveTime;
      data.isOnSiteMember = this.isOnSiteMember;
      data.isUnrecognizedActivity = this.isUnrecognizedActivity;

      if (this.mailLink == this.mailLinkEmailFlag) {
        data.email = this.email;

        if (this.isDailyReport) {
          if (this.selectedDailyReportLocations.length != 0) {
            data.dailyReportLocations = this.selectedDailyReportLocations;
          }

          if (this.selectedDailyReportRoles.length != 0) {
            data.dailyReportRoles = this.selectedDailyReportRoles;
          }
        }

        if (this.isVisitor) {
          if (this.selectedVisitorLocation.length != 0) {
            data.visitorLocations = this.selectedVisitorLocation;
          }
        }

        if (this.isBankedTime) {
          if (this.selectedBankedTimeReportLocations.length != 0) {
            data.bankedTimeLocations = this.selectedBankedTimeReportLocations;
          }
          if (this.selectedBankedTimeReportRoles.length != 0) {
            data.bankedTimeRoles = this.selectedBankedTimeReportRoles;
          }
        }

        if (this.isLeaveTime) {
          if (this.selectedLeaveTimeReportLocations.length != 0) {
            data.leaveTimeLocations = this.selectedLeaveTimeReportLocations;
          }
          if (this.selectedLeaveTimeReportRoles.length != 0) {
            data.leaveTimeRoles = this.selectedLeaveTimeReportRoles;
          }
        }

        if (this.isOnSiteMember) {
          if (this.selectedOnSiteReportLocations.length != 0) {
            data.onSiteLocations = this.selectedOnSiteReportLocations;
          }
        }

        if (this.isUnrecognizedActivity) {
          if (this.selectedUnrecognizedActivityReportLocations.length != 0) {
            data.unrecognizedActivitylocations = this.selectedUnrecognizedActivityReportLocations;
          }
        }
      }
      return data;
    },

    addClicked() {
      if (!this.validate()) {
        return;
      }

      if (this.isAddMode) {
        this.addMail();
      } else if (this.isEditMode) {
        this.updateMail();
      }
    },


    validate() {
      if (this.mailLink == this.mailLinkUserFlag) {
        if (this.selectedManager == -1) {
          alert("Select manager");
          return false;
        }
      } else if (this.mailLink == this.mailLinkEmailFlag) {
        var reg = /.+@.+/;
        if (reg.test(this.email) == false) {
          alert("Invalid Email Address");
          return false;
        }
      }

      if (
        !this.isDailyReport &&
        !this.isBankedTime &&
        !this.isLeaveTime &&
        !this.isOnSiteMember &&
        !this.isVisitor &&
        !this.isUnrecognizedActivity
      ) {
        alert("Select atleast one option");
        return false;
      }

      if (
        this.mailLink == this.mailLinkEmailFlag &&
        this.selectedDailyReportLocations.length == 0 &&
        this.selectedDailyReportRoles.length == 0 &&
        this.selectedVisitorLocation.length == 0 &&
        this.selectedBankedTimeReportLocations.length == 0 &&
        this.selectedBankedTimeReportRoles.length == 0 &&
        this.selectedLeaveTimeReportLocations.length == 0 &&
        this.selectedLeaveTimeReportRoles.length == 0 &&
        this.selectedOnSiteReportLocations.length == 0 &&
        this.selectedUnrecognizedActivityReportLocations.length == 0
      ) {
        alert("Select atleast one role/location");
        return false;
      }

      if (this.mailLink == this.mailLinkEmailFlag) {

      }
      return true;
    },

    async addMail() {
      var instance = this;
      instance.isLoading = true;

      var data = this.formatData();


      await axios.post(`${VUE_APP_API_BASE_URL}/mail/add`, { data: data })
        .then(function (response) {
          if (response.data.status) {
            instance.$emit("onMailAdded");
            instance.$toast.success(response.data.message);
            instance.closeClicked();
          } else {
            instance.$toast.error(response.data.message);
          }
        })
        .catch(error => {
          instance.$toast.error(error);
        })
        .then(() => {
          instance.isLoading = false;
        });
    },
    async updateMail() {
      var instance = this;
      instance.isLoading = true;

      var data = this.formatData();

      await axios.post(`${VUE_APP_API_BASE_URL}/mail/update`, { mailId: this.mailId, data: data })
        .then(function (response) {
          if (response.data.status) {
            instance.$emit("onMailAdded");
            instance.$toast.success(response.data.message);
            instance.closeClicked();
          } else {
            instance.$toast.error(response.data.message);
          }
        })
        .catch(error => {
          instance.$toast.error(error);
        })
        .then(() => {
          instance.isLoading = false;
        });
    },

    
    async getCompanyRoles() {
      try {
        const response = await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`);
        if (response.data.status) {
          this.allRoles = response.data.data.map(role => ({
            id: String(role.id),
            name: role.name
          }));
          console.log('Roles:', this.allRoles);
        } else {
          this.errorMessage = response.data.message || response.data.errors;
        }
      } catch (error) {
        console.error(error);
      }
    },

    // async getCompanyRoles() {
    //   var instance = this;
    //   await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
    //     .then((response) => {
    //       if (response.data.status) {
    //         instance.allRoles = response.data.data
    //         instance.allRoles.forEach(element => {
    //           delete element['created_at'];
    //           delete element['updated_at'];
    //         });
    //         console.log(instance.allRoles);
    //       } else {
    //         instance.errorMessage = response.data.message || response.data.errors;
    //       }
    //     }).catch(function (error) {
    //       console.log(error);
    //     });
    // },

    //  getAllRoles() {
    //   var instance = this;
    //   instance.isLoading = true;
    //   instance.allRoles = [];
    //   this.$http
    //     .post(ROLE_GET)
    //     .then(function(response) {
    //       var roles = response.data.roles;

    //       roles.forEach(role => {
    //         var r = [];
    //         r["id"] = role.id;
    //         r["name"] = role.name;
    //         instance.allRoles.push(r);
    //       });
    //     })
    //     .catch(error => {
    //       alert(error);
    //     })
    //     .then(function() {
    //       instance.isLoading = false;
    //     });
    // },


    async getLocationIds() {
      var instance = this;
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            instance.allLocations = response.data.data
            instance.allLocations.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              delete element['latitude'];
              delete element['longitude'];
            }
            
            )
            console.log(instance.allLocations);
          } else {
            this.errorMessage = response.data.message || response.data.errors;
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },

    setDeteteId(id){
      this.deteteId = id
    },

   async deleteMail(){
         await axios.post(`${VUE_APP_API_BASE_URL}/mail/remove`, { mailId: this.deteteId }).then((response)=>{
        if(response.data.status){
          var instance = this;
         instance.$emit("onMailAdded");
         instance.$toast.success(response.data.message);
        }else {
            instance.$toast.error(response.data.message || response.data.errors);
          }
      }).catch(function (error){
        console.log(error);
      });
    }


    // getAllLocations() {
    //   var instance = this;
    //   instance.isLoading = true;
    //   instance.allLocations = [];

    //   this.$http
    //     .post(GET_ALL_LOCATIONS)
    //     .then(function(response) {
    //       var locations = response.data.locations;

    //       locations.forEach(location => {
    //         var r = [];
    //         r["id"] = location.id;
    //         r["name"] = location.name;
    //         instance.allLocations.push(r);
    //       });
    //     })
    //     .catch(error => {
    //       alert(error);
    //     })
    //     .then(function() {
    //       instance.isLoading = false;
    //     });
    // }


  },


};
</script>
